import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { SelectInPopoverOption } from './select-in-popover-option';

// TODO remove this component (use select-ionic-popover instead)

/**
 * If one option is selected when the SelectInPopoverComponent is displayed,
 * that option will be displayed with a checkmark, and isSelected will be updated on options
 * as necessary when the popover is dismissed.
 * If no option is selected when created, SelectInPopoverComponent will not update isSelected
 */
@Component({
  selector: 'app-select-in-popover',
  templateUrl: './select-in-popover.component.html',
  styleUrls: ['./select-in-popover.component.scss'],
})
export class SelectInPopoverComponent implements OnInit {
  @Input() elements: SelectInPopoverOption[] = [];
  @Input() dismissFn: (element: any) => void;

  @HostBinding('class.check-mark-mode') isCheckMarkMode;

  ngOnInit() {
    this.isCheckMarkMode = this.elements.some(element => element.isSelected);
  }

  selectElement(selected) {
    if (this.isCheckMarkMode) {
      for (const element of this.elements) {
        element.isSelected = element === selected;
      }
    }
    this.dismissFn(selected);
  }
}
